import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global hook: surface 402 (Payment Required) as a friendly toast with an
// "Upgrade" link instead of a raw error inside every page.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 402) {
      // Lazy import to avoid a circular boot ordering with sonner.
      import("sonner").then(({ toast }) => {
        const msg = formatApiError(error.response.data?.detail) || "This is a Pro feature.";
        toast.error(msg, {
          duration: 6000,
          action: {
            label: "Upgrade",
            onClick: () => { window.location.href = "/pricing"; },
          },
        });
      });
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
